// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bw_bX","inline":"bw_dS","inlineBlock":"bw_dT","quote":"bw_dV","icon":"bw_df","medium":"bw_dW","big":"bw_dX","large":"bw_dY"};